export default __webpack_public_path__ + "static/media/zestimate.c750ee0d.png";